import React, { useState } from 'react'
import { Form, Button, Row, Col, Alert } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useAdminSections } from 'api/hooks/use-admin-sections'
import { useAdminSystems } from 'api/hooks/use-admin-systems'
import { useCreateAdminMunicipalitySection } from 'api/hooks/use-admin-municipality-sections'

const AddMunicipalitySectionForm = ({ municipalityId, assignedSectionIds }) => {
  const { data: sections, isLoading: sectionsLoading } = useAdminSections()
  const { data: systems } = useAdminSystems()
  const [sectionId, setSectionId] = useState('')
  const [systemId, setSystemId] = useState('')

  const { mutate: createSection, isLoading: saving, error } = useCreateAdminMunicipalitySection({
    municipalityId,
    options: {
      onSuccess: () => {
        setSectionId('')
        setSystemId('')
        toast.success('Module added')
      },
      onError: (err) => toast.error(err?.response?.data?.message || 'Failed to add module')
    }
  })

  const availableSections = (sections || []).filter((s) => !assignedSectionIds.includes(s.id))

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!sectionId) return

    // section_id and system_id are UUIDs — pass them through as strings.
    const params = { section_id: sectionId }
    if (systemId) params.system_id = systemId
    createSection(params)
  }

  return (
    <Form onSubmit={handleSubmit} className="mb-4 pb-3 border-bottom">
      <h6 className="mb-2">Add Module</h6>
      {error && (
        <Alert variant="danger" className="py-2 small mb-2">
          {error.response?.data?.message || error.message}
        </Alert>
      )}
      <Row className="g-2 align-items-end">
        <Col md={4}>
          <Form.Group>
            <Form.Label className="small mb-1">Section</Form.Label>
            <Form.Select
              size="sm"
              value={sectionId}
              onChange={(e) => setSectionId(e.target.value)}
              disabled={sectionsLoading || saving}
              required
            >
              <option value="">— Select a section —</option>
              {availableSections.map((s) => (
                <option key={s.id} value={s.id}>{s.name} ({s.abbreviation})</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label className="small mb-1">System (optional)</Form.Label>
            <Form.Select
              size="sm"
              value={systemId}
              onChange={(e) => setSystemId(e.target.value)}
              disabled={saving}
            >
              <option value="">— None —</option>
              {(systems || []).map((sys) => (
                <option key={sys.id} value={sys.id}>{sys.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Button type="submit" variant="primary" size="sm" disabled={saving || !sectionId}>
            {saving ? 'Adding…' : 'Add Module'}
          </Button>
        </Col>
      </Row>
      {availableSections.length === 0 && !sectionsLoading && (
        <Form.Text className="text-muted">All available sections are already assigned.</Form.Text>
      )}
    </Form>
  )
}

export default AddMunicipalitySectionForm
